import React, { useState } from "react";
import DashboardEdit from "./Components/DashboardEdit";
// import DashboardFAQViewMore from "./FAQ/DashboardFAQViewMore";
// import DashboardFAQEdit from "./DashboardFAQEdit";
import DashboardViewMore from "./Components/DashboardViewMore";
import { useNavigate } from "react-router-dom";

const ReusableTable = ({
  headers,
  data,
  rowKey,
  defaultSortKey,
  tableClassName = "",
  headerClassName = "",
  rowClassName = "",
  tableApis,
  onTableUpdate,
  onPageChange,
  onPerPageChange,
  queries,
  type = "faq",
  onAction,
}) => {
  const [tableData, setTableData] = useState(data);
  const [sortConfig, setSortConfig] = useState({
    key: defaultSortKey || "",
    direction: "asc",
  });
  const [dropdownIndex, setDropdownIndex] = useState(null);
  const [viewData, setViewData] = useState(null); // State for selected "View More" data
  const [showViewMore, setShowViewMore] = useState(false);
  const [showEdit, setShowEdit] = useState(false); // State for the Edit modal
  const [editData, setEditData] = useState(null); // Data for editing
  const navigate = useNavigate();

  React.useEffect(() => {
    setTableData(data);
  }, [data]);

  const handleSort = (key) => {
    const direction =
      sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
    const sortedData = [...tableData].sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });
    setSortConfig({ key, direction });
    setTableData(sortedData);
  };

  // const handleActionClick = async (action, row) => {
  //   if (action === "Employee") {
  //     const response = await tableApis.getById(row[rowKey]);
  //     const id =
  //       response.created_by ||
  //       response.createdby ||
  //       response.data.createdby ||
  //       "";
  //     console.log("resonse employee id", id);
  //     // Navigate to employee profile page
  //     if (id) {
  //       const creatorInfo = row.creator || null;
  //       navigate(`/hr/employees/${id}`, { state: creatorInfo });
  //     }
  //   } else if (action === "View") {
  //     // try {
  //     //   const response = await tableApis.getById(row[rowKey]);
  //     //   setViewData(response); // Store the detailed data
  //     //   setShowViewMore(true); // Show the View More component
  //     // } catch (err) {
  //     //   console.error("Error fetching entry details:", err);
  //     // }
  //     if(onAction){
  //       onAction('view', row);
  //     }
  //   } else if (action === "Edit") {
  //     // const response = await tableApis.getById(row[rowKey]);
  //     // setEditData(response); // Set the data for the Edit modal
  //     // setShowEdit(true); // Show the Edit modal
  //     if(onAction){
  //       onAction('edit', row);
  //     }
  //   } else if (action === "Delete") {
  //     console.log("Delete clicked for", row.id);
  //     try {
  //       await tableApis.deleteById(row.id);
  //       if (onTableUpdate) onTableUpdate();
  //     } catch (err) {
  //       console.error("Error deleting entry:", err);
  //     }
  //   }
  // };
  const handleActionClick = async (action, row) => {
    if (action === "Employee") {
      const response = await tableApis.getById(row[rowKey]);
      const id =
        response.created_by ||
        response.createdby ||
        response.data?.createdby ||
        "";
      console.log("response employee id", id);
      // Navigate to employee profile page
      if (id) {
        const creatorInfo = row.creator || null;
        navigate(`/hr/employees/${id}`, { state: creatorInfo });
      }
    } else if (action === "View" || action === "view") {
      if(onAction) {
        console.log("Triggering view action with row data:", row);
        onAction('view', row);
      }
    } else if (action === "Edit" || action === "edit") {
      if(onAction) {
        console.log("Triggering edit action with row data:", row);
        onAction('edit', row);
      }
    } else if (action === "Delete" || action === "delete") {
      if(onAction) {
        onAction('delete', row);
      } else {
        console.log("Delete clicked for", row.id);
        try {
          await tableApis.deleteById(row.id);
          if (onTableUpdate) onTableUpdate();
        } catch (err) {
          console.error("Error deleting entry:", err);
        }
      }
    }
  };

  const handleActionPerPage = (newPerPage) => {
    if (onPerPageChange) onPerPageChange(newPerPage);
  };

  const handleActionPage = async (newPage) => {
    if (onPageChange) onPageChange(newPage);
    setTimeout(() => {
      if (onTableUpdate) onTableUpdate();
    }, 100);
  };

  const toggleDropdown = (index) => {
    setDropdownIndex(index === dropdownIndex ? null : index);
  };

  const closeDropdown = () => setDropdownIndex(null);

  // if (showViewMore && type === "faq" && viewData) {
  //   return (
  //     <DashboardFAQViewMore
  //       data={viewData}
  //       onClose={() => setShowViewMore(false)} // Close the View More component
  //     />
  //   );
  // }

  // if (showEdit && type === "faq" && editData) {
  //   return (
  //     <DashboardFAQEdit
  //       data={editData}
  //       onClose={() => setShowEdit(false)}
  //       onSave={(updatedData) => {
  //         setShowEdit(false);
  //         tableApis
  //           .updateById(updatedData.id, updatedData)
  //           .then(() => {
  //             console.log("FAQ updated successfully");
  //             if (onTableUpdate) onTableUpdate(); // Trigger a refresh only after the update completes
  //           })
  //           .catch((error) => {
  //             console.error("Error updating FAQ:", error);
  //           });
  //       }}
  //     />
  //   );
  // }

  return (
    <div className="container text-black font-ubuntu shadow-lg h-[150vh]">
      {/* {showViewMore && viewData && (
        <DashboardViewMore
          data={viewData}
          onClose={() => setShowViewMore(false)} // Close the View More component
          type={type}
        />
      )}
      {showEdit && editData && (
        <DashboardEdit
          data={editData}
          onClose={() => setShowEdit(false)}
          onSave={(updatedData) => {
            console.log("inside save in update, ", updatedData);
            // Determine the ID based on the type of updatedData
            let id;
            let dataToUpdate;

            if (updatedData instanceof FormData) {
              id = updatedData.get("id");
              dataToUpdate = updatedData; // Use FormData as is
            } else {
              id = updatedData.id;
              dataToUpdate = updatedData; // Use object as is
            }
            setShowEdit(false);
            tableApis
              .updateById(id, dataToUpdate)
              .then(() => {
                console.log("updated successfully");
                if (onTableUpdate) onTableUpdate(); // Trigger a refresh only after the update completes
              })
              .catch((error) => {
                console.log("Error updating:", error);
              });
          }}
          type={type}
        />
      )} */}
      <div className="bg-white shadow-lg">
        <h2 className="text-2xl font-bold mb-4 py-4 px-5"></h2>
        <table className={` w-full ${tableClassName}`}>
          <thead>
            <tr>
              {headers.map(({ key, label, sortable }) => (
                <th
                  key={key}
                  className={`py-2 px-4 font-normal text-gray-600 text-start ${headerClassName} ${
                    sortable ? "cursor-pointer hover:underline" : ""
                  }`}
                  onClick={sortable ? () => handleSort(key) : undefined}
                >
                  {label}{" "}
                  {sortConfig.key === key
                    ? sortConfig.direction === "asc"
                      ? "↑"
                      : "↓"
                    : ""}
                </th>
              ))}
              <th
                className={`py-2 px-4 font-normal text-gray-600 text-start ${headerClassName}`}
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {tableData.length > 0 ? (
              tableData.map((row, idx) => (
                <tr
                  key={row[rowKey]}
                  className={`h-16 border text-start ${
                    idx % 2 === 0 ? "bg-white" : "bg-white"
                  } ${rowClassName}`}
                >
                  {headers.map(({ key }, headerIdx) => (
                    <td
                      key={key}
                      className={`py-2 px-4 ${
                        headerIdx === 2 ? "cursor-pointer hover:underline" : ""
                      } ${
                        headerIdx === 1 ? "cursor-pointer hover:underline" : ""
                      }`}
                      onClick={
                        headerIdx === 2
                          ? () => handleActionClick("View", row) // Trigger "View More" when clicking the second header cell
                          : headerIdx === 1
                          ? () => handleActionClick("Employee", row) // Trigger "Employee More" when clicking the third header cell
                          : undefined
                      }
                    >
                      {row[key]}
                    </td>
                  ))}
                  <td className="py-2 pl-6 text-start relative">
                    <button
                      className="text-gray-500 hover:text-gray-700"
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleDropdown(idx);
                      }}
                    >
                      <i className="fas fa-ellipsis-h text-blue-500"></i>
                    </button>
                    {dropdownIndex === idx && (
                      <div
                        className="absolute right-0 mt-2 w-40 bg-white border rounded shadow-md z-10"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <ul className="list-none">
                          <li
                            className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                            onClick={() => {
                              handleActionClick("View", row);
                              toggleDropdown(null); // Close dropdown after click
                            }}
                          >
                            View More
                          </li>
                          <li
                            className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                            onClick={() => {
                              handleActionClick("Edit", row);
                              toggleDropdown(null); // Close dropdown after click
                            }}
                          >
                            Edit
                          </li>
                          <li
                            className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                            onClick={() => {
                              handleActionClick("Delete", row);
                              toggleDropdown(null); // Close dropdown after click
                            }}
                          >
                            Delete
                          </li>
                        </ul>
                      </div>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={headers.length + 1} className="text-start py-4">
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* Pagination and Filters */}
      <div className="mt-4 flex flex-wrap items-center justify-between bg-white p-4 rounded-lg shadow-lg">
        <div className="flex items-center">
          <span className="mr-2">Show</span>
          <select
            className="border rounded p-1"
            value={queries.per_page}
            onChange={(e) => {
              const newPerPage = parseInt(e.target.value, 10);
              handleActionPerPage(newPerPage);
            }}
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
          </select>
          <span className="ml-2">entries</span>
        </div>
        <div className="text-sm mt-2 sm:mt-0">
          {(() => {
            const startEntry = (queries.page - 1) * queries.per_page + 1;
            const endEntry = queries.page * queries.per_page;
            return `Showing ${startEntry} to ${endEntry} entries`;
          })()}
        </div>
        <div className="flex mt-2 sm:mt-0">
          <button
            className="px-3 py-1 border rounded mr-2 bg-gray-100 text-gray-600"
            disabled={queries.page <= 1}
            onClick={() => handleActionPage(queries.page - 1)}
          >
            Previous
          </button>
          <button
            className="px-3 py-1 border rounded bg-gray-100 text-gray-600 hover:text-gray-500"
            onClick={() => handleActionPage(queries.page + 1)}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReusableTable;
